import React from 'react';
import Btn, { ButtonRefType } from '../Btn';
import { BtnModifier } from '../Btn';
import { TooltipPlacement } from '../../../atoms/Tooltip';
import { SharedButtonProps } from './SharedButtonProps';

type ButtonActionSpecificProps = {
  text?: string;
  transparent?: boolean;
  type?: 'button' | 'submit' | 'reset';
  href?: string;
  routing?: boolean;
  reference?: ButtonRefType;
  focusOnMount?: boolean;
  tooltipPlacement?: TooltipPlacement;
  children?: React.ReactNode;
};

export type ButtonActionProps = SharedButtonProps & ButtonActionSpecificProps;

export function ButtonAction({
  text,
  transparent = false,
  onClick,
  disabled,
  ariaDisabled,
  type = 'button',
  ariaLabel,
  ariaDescribedBy,
  href,
  routing,
  reference,
  focusOnMount,
  tooltipPlacement,
  children,
  ...rest
}: ButtonActionProps) {
  const modifier = transparent ? [BtnModifier.SINGLE_ACTION, BtnModifier.TRANSPARENT] : [BtnModifier.SINGLE_ACTION];

  return (
    <Btn
      {...rest}
      modifier={modifier}
      text={text}
      onClick={onClick}
      disabled={disabled}
      ariaDisabled={ariaDisabled}
      type={type}
      ariaLabel={ariaLabel}
      ariaDescribedBy={ariaDescribedBy}
      href={href}
      routing={routing}
      reference={reference}
      focusOnMount={focusOnMount}
      tooltipPlacement={tooltipPlacement}
    >
      {children}
    </Btn>
  );
}
